var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "container content-padding" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v("\n        Terms and Conditions\n      ")
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("เงื่อนไขและข้อตกลงในการใช้บริการ")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "ขอต้อนรับท่านเข้าสู่การใช้งานบน www.BeNeat.co และ BeNeat Application (“เว็บไซต์”) ภายใต้การจัดการดูแลของ บริษัท บีนีท จำกัด (“บริษัท”)\n          เว็บไซต์นี้อยู่ภายใต้บังคับของข้อตกลงและเงื่อนไขดังต่อไปนี้ การที่ท่านทำการซื้อสินค้าจากเว็บไซต์นี้ ถือว่าท่านได้ยอมผูกพันและตกลงยินยอมตามข้อตกลงและเงื่อนไขดังกล่าว\n          หากท่านไม่เห็นด้วยตามข้อตกลงฉบับนี้ ไม่ว่าจะทั้งหมดหรือบางส่วน รวมไปถึงข้อตกลงที่อาจแก้ไขใหม่ ท่านสามารถยุติการใช้งานเว็บไซต์นี้ได้ทันที"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("ข้อตกลงทั่วไป")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          ถ้อยคำที่ระบุภายใต้ข้อตกลงและเงื่อนไขฉบับนี้ ให้มีความหมายดังต่อไปนี้ "
              ),
              _c("br"),
              _vm._v(
                "\n          “บริษัท” “ของเรา” และ “เรา” หมายความถึง แบรนด์ BeNeat "
              ),
              _c("br"),
              _vm._v(
                "\n          “ท่าน” หมายความถึง ผู้ใช้บริการที่สั่งซื้อสินค้า ไม่ว่ามีสถานะเป็นบุคคลธรรมดา หรือนิติบุคคล "
              ),
              _c("br"),
              _vm._v(
                "\n          “สินค้า” หมายความถึง สินค้าใดๆ หรือ สินค้าทั้งหมด หรือบริการอื่นๆ ที่จำหน่ายทางเว็บไซต์นี้ "
              ),
              _c("br"),
              _vm._v(
                "\n          “เว็บไซด์” หมายถึง เว็บไซด์ www.BeNeat.co และ Application BeNeat "
              ),
              _c("br"),
              _vm._v(
                "\n          “ราคาสินค้า” หมายถึง ราคาของสินค้าที่รวมภาษีมูลค่าเพิ่มแล้ว หรือราคาสินค้าที่อยู่ในโปรโมชั่นการลดราคาที่รวมภาษีมูลค่าเพิ่มแล้ว "
              ),
              _c("br"),
              _vm._v(
                "\n          “ส่วนลด” หมายถึง ส่วนลดจากราคาสินค้า หรือจากรายการส่งเสริมทางการตลาดของบริษัท "
              ),
              _c("br"),
              _vm._v(
                "\n          “คู่สัญญา” หมายถึง บริษัท กับ ลูกค้า\n          "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n          เงื่อนไขฉบับนี้ ถือเป็นสัญญาซื้อขายสินค้าและ/หรือผลิตภัณฑ์ ระหว่างบริษัทกับท่าน ผู้ใช้บริการเว็บไซต์ซึ่งเป็นลูกค้าของบริษัท "
              ),
              _c("br"),
              _vm._v(
                "\n          เงื่อนไขและข้อตกลงการซื้อขาย ให้เป็นไปตามตามข้อตกลงนี้ กรณีเกิดความขัดแย้งหรือแตกต่างใดๆอันเกิดจากการซื้อขายสินค้า "
              ),
              _c("br"),
              _vm._v(
                "\n          และ/หรือ ผลิตภัณฑ์จากเว็บไซด์ บริษัทจะถือเอาข้อตกลงนี้เป็นสำคัญ "
              ),
              _c("br"),
              _vm._v(
                "\n          บริษัทขอสงวนสิทธิ์ในการแก้ไข ดัดแปลง เปลี่ยนแปลง หรือยกเลิกข้อตกลงและเงื่อนไข รวมถึงข้อตกลงอื่นๆ บนเว็บไซต์ โดยมิต้องแจ้งท่านให้ทราบล่วงหน้า "
              ),
              _c("br"),
              _vm._v(
                "\n          ข้อมูลทั้งหมดที่แสดงไว้ในเว็บไซต์ เป็นเพียงการแสดงของมูลต่างๆของสินค้าและ/หรือผลิตภัณฑ์ มิให้ถือเป็นคำเสนอขายสินค้าของบริษัทแต่อย่างใด "
              ),
              _c("br"),
              _vm._v(
                "\n          ในทางกลับกัน การที่ท่านส่งคำสั่งซื้อผ่านทางเว็บไซต์นี้มายังเรา "
              ),
              _c("br"),
              _vm._v(
                " ให้ถือว่าท่านได้ทำคำเสนอเพื่อซื้อสินค้าที่ท่านได้เลือกในเว็บไซต์ตามข้อตกลงและเงื่อนไขฉบับนี้มายังบริษัท "
              ),
              _c("br"),
              _vm._v(
                "\n          ซึ่งทางบริษัทจะต้องพิจารณาและตรวจสอบสินค้าและความพร้อมส่งสินค้าก่อนตอบรับคำเสนอซื้อของท่าน "
              ),
              _c("br"),
              _vm._v(
                "\n          บริษัทขอสงวนสิทธิ์ในการแก้ไข ดัดแปลง เปลี่ยนแปลง หรือยกเลิกข้อตกลงและเงื่อนไข รวมถึงข้อตกลงอื่นๆ บนเว็บไซต์ โดยมิต้องแจ้งให้ทราบล่วงหน้า "
              ),
              _c("br"),
              _vm._v(
                "\n          การทำคำสั่งซื้อ และ/หรือการปฏิเสธ และ/หรือการยกเลิกสินค้า ของท่านย่อมถือเป็นการกระทำของท่านที่ ผูกพันตามคำสั่งดังกล่าวตามกฎหมายทุกประการ "
              ),
              _c("br"),
              _vm._v(
                "\n          ท่านจะต้องเก็บรักษา “ชื่อผู้ใช้งาน” และ “รหัสผ่าน” ของท่านให้เป็นความลับ กรณีที่ท่านจำชื่อบัญชีหรือรหัสผ่านไม่ได้ "
              ),
              _c("br"),
              _vm._v(
                "\n          ทางบริษัทจะไม่รับผิดชอบต่อความสูญหรือเสียหายอย่างใดๆอันเนื่องมาจากการดังกล่าว และให้หมายความรวมถึงกรณีที่ผู้อื่นนำชื่อบัญชีและรหัสผ่านของท่านไปใช้โดยที่ไม่ได้รับความยินยอมจากท่าน "
              ),
              _c("br"),
              _vm._v(
                "\n          หากท่านทราบการดังกล่าว ท่านจะต้องแจ้งให้บริษัททราบทันทีเพื่อกระทำการยกเลิกคำสั่งซื้อหรือคำเสนอซื้อนั้นๆ\n          "
              ),
              _c("br"),
              _vm._v(
                "\n          หรือทำการอย่างใดๆ อันเกิดกับการดังกล่าวรวมถึงธุรกรรมที่เกี่ยวข้องกับการนั้นๆด้วย "
              ),
              _c("br"),
              _vm._v("\n          กรณีเกิดเหตุดังกล่าว กรุณาติดต่อ Email : "),
              _c("a", { attrs: { href: "mailto:info@beneat.co" } }, [
                _vm._v("info@beneat.co")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n          เมื่อท่านเข้าใช้เว็บไซต์นี้ บริษัทถือว่าท่านยินยอมให้บริษัทดำเนินการจัดการข้อมูลของท่านได้ ไม่ว่าท่านจะได้ทำการลงทะเบียนเข้าใช้งานเว็บไซต์ก่อนหรือไม่ก็ตาม "
              ),
              _c("br"),
              _vm._v(
                "\n          ในการบริการและคุณสมบัติที่เกี่ยวข้องกับการลงทะเบียนสมาชิกหรือลงทะเบียนเพื่อขอรับข้อมูลเพิ่มเติม ท่านจำเป็นต้องยินยอมที่จะให้ข้อมูลที่ถูกต้องและเป็นข้อมูลที่ถูกปรับปรุงล่าสุดอยู่เสมอ\n          ในกรณีที่ท่าน ไม่สามารถจำรหัสผ่านหรือบัญชีของท่านได้ ทางบริษัทจะไม่รับผิดชอบทั้งทางตรงหรือทางอ้อม "
              ),
              _c("br"),
              _vm._v(
                "\n          ต่อการสูญหายหรือความเสียหายที่เกิดขึ้น อันเป็นผลจากการใดๆ หรือมีความเกี่ยวข้องกับความล้มเหลวของท่านในการนี้ "
              ),
              _c("br"),
              _vm._v(
                "\n          กรณีที่ท่านทราบว่ามีผู้อื่นนำชื่อบัญชีและรหัสผ่านของท่านไปใช้ โดยท่านมิได้ให้ความยินยอมไม่ว่าเพื่อวัตถุประสงค์ใดก็ตาม ท่านต้องแจ้งให้บริษัททราบทันที "
              ),
              _c("br"),
              _vm._v(
                "\n          เพื่อบริษัทจะได้ยกเลิกการทำรายการสั่งซื้อสินค้า/บริการ หรือการธุรกรรมรายการใดๆ ที่เกิดขึ้นจากการกระทำดังกล่าว"
              ),
              _c("br"),
              _vm._v(" โดยสามารถแจ้งเรื่องมาได้ทางอีเมล์ของบริษัท\n        ")
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("ทรัพย์สินทางปัญญา")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          เนื้อหาต่างๆ ทั้งที่เป็นลายลักษณ์อักษร รูปภาพ บรรดาข้อมูล เสียง ภาพถ่าย คลิปวีดีโอ รูปแบบของเว็บไซต์ "
              ),
              _c("br"),
              _vm._v(
                "\n          ข้อความผลิตภัณฑ์สินค้า และบทความอื่นใด ที่ปรากฏในเว็บไซต์นี้ รวมถึงช่องการขาย และเครื่องหมายทางการค้า "
              ),
              _c("br"),
              _vm._v(
                "\n          ที่ถือครองโดยบริษัท เป็นลิขสิทธิ์ของบริษัท อันได้รับความคุ้มครองตามกฎหมายเกี่ยวกับทรัพย์สินทางปัญญา "
              ),
              _c("br"),
              _vm._v(
                "\n          ทั้งหรือบริษัทได้รับอนุญาตจากผู้มีสิทธิดังกล่าวให้สามารถใช้เป็นส่วนหนึ่งของ เว็บไซต์นี้ได้ "
              ),
              _c("br"),
              _vm._v(
                "\n          เครื่องหมายการค้า ชื่อทางการค้า โลโก้ ตราสัญลักษณ์ สโลแกน โนว์ฮาว ข้อมูล ความลับทางการค้า ทั้งที่จดทะเบียนแล้วและยังไม่ได้จดทะเบียน "
              ),
              _c("br"),
              _vm._v(
                "\n          หรือที่อาจมีสิทธิจะได้จดทะเบียน รวมถึงสิทธิในทรัพย์สินอื่นๆ ที่ทางบริษัทใช้หรือพัฒนา ล้วนอยู่ภายใต้การคุ้มครองของกฎหมายทรัพย์สินทางปัญญาที่เกี่ยวข้อง และกฎหมายอื่นๆ ของราชอาณาจักรไทย\n          บริษัทมีอำนาจควบคุมมิให้เกิดการทำซ้ำ ดัดแปลง จัดเก็บ ถ่ายโอน ลอกเลียนแบบ เผยแพร่ต่อสาธารณชน หรือกระทำการใดๆ ในข้อมูลเนื้อหาดังกล่าว หากผู้ใดฝ่าฝืนจะเป็นการกระทำอันละเมิดลิขสิทธิ์หรือสิทธิในทรัพย์สินทางปัญญาโดยไม่ได้รับความยินยอมล่วงหน้าเป็นลายลักษณ์อักษรจากบริษัท\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("ราคาและรายละเอียดของสินค้า")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทจะใช้ความพยายามตามสมควรเพื่อดำเนินการให้แน่ใจว่าราคาและรายละเอียดของสินค้าที่แสดงในเว็บไซต์มีความถูกต้อง"
              ),
              _c("br"),
              _vm._v(
                "\n          อย่างไรก็ตาม บริษัทขอสงวนสิทธิ์ที่จะเปลี่ยนแปลงราคาและรายละเอียดอื่นของสินค้าดังกล่าวโดยไม่จำเป็นต้องแจ้งล่วงหน้า "
              ),
              _c("br"),
              _vm._v(
                "\n          โดยบริษัทไม่ต้องรับผิดชอบหรือมีความรับผิดไม่ว่าในทางใดสำหรับความผิดพลาดของราคาสินค้าที่อาจปรากฏในเว็บไซต์ "
              ),
              _c("br"),
              _vm._v(
                "\n          และบริษัทขอสงวนสิทธิ์ที่จะปฏิเสธคำสั่งซื้อที่อ้างอิงจากความผิดพลาดของราคาดังกล่าวบนเว็บไซต์นี้ซึ่งใช้สำหรับการซื้อผ่านทางออนไลน์เท่านั้น ทั้งนี้ "
              ),
              _c("br"),
              _vm._v(
                "\n          ราคาสินค้าชนิดเดียวกันอาจแตกต่างกันที่ในทางช่องทางขายอื่นได้นอกจากนั้น ราคาที่แสดงไว้ในเว็บไซต์นี้ใช้บังคับและมีผลสมบูรณ์สำหรับการจัดส่งสินค้าภายในประเทศไทยเท่านั้น\n          บริษัทพยายามให้คำอธิบายของผลิตภัณฑ์ ข้อมูลสินค้า ภาพถ่ายของสินค้า หรือคำบรรยายในเว็บไซต์ ให้มีความถูกต้องและแม่นยำที่สุด "
              ),
              _c("br"),
              _vm._v(
                "\n          เท่าที่จะทำได้ ท่านยอมรับและเห็นชอบว่า การเข้าใช้งานอาจมีความคลาดเคลื่อนของข้อมูล หากท่านพบว่ารายละเอียดสินค้าไม่ตรงกับความเป็นจริง "
              ),
              _c("br"),
              _vm._v(
                "\n          ท่านสามารถดำเนินการเพื่อขอรับบริการหลังการขายและ/หรือขอรับเงินคืน หรือขอเปลี่ยนผลิตภัณฑ์ใหม่ซึ่งสอดคล้องกับนโยบายการรับ-คืนสินค้าของบริษัท "
              ),
              _c("br"),
              _vm._v(
                "\n          ท่านตกลงและทราบดีว่า รูปภาพและข้อมูลของสินค้าทั้งหมดที่แสดงทางเว็บไซด์นี้ เป็นการจัดแสดงไว้ตามสภาพที่เป็นอยู่ "
              ),
              _c("br"),
              _vm._v(
                "\n          และมีวัตถุประสงค์เพียงเพื่อแสดงให้ลูกค้าทราบถึงลักษณะสินค้าเท่านั้น ขนาด คุณภาพ ความสูง และสี "
              ),
              _c("br"),
              _vm._v(
                "\n          ของสินค้าที่แท้จริงอาจจะแตกต่างจากรูปภาพและข้อมูลที่ปรากฏบนเว็บไซต์ ราคาสินค้าในแต่ละช่วงเวลา อาจมีการเปลี่ยนแปลงตามโปรโมชั่นการขายของบริษัท "
              ),
              _c("br"),
              _vm._v(
                "\n          บริษัทขอสงวนสิทธิ์ในการเปลี่ยนแปลงราคา โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า การเปลี่ยนแปลงราคาใดๆ จะไม่มีผลกระทบต่อคำสั่งซื้อที่ได้รับการยืนยันจากบริษัทเรียบร้อยแล้ว\n          และให้หมายรวมไปถึงคำสั่งซื้อที่ได้รับการยืนยันและมีการจัดส่งสินค้าให้ท่านอย่างสมบูรณ์แล้ว\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("ความพร้อมในการจัดส่งสินค้า")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทจะแสดงความพร้อมในการจัดส่งสินค้าแต่ละชนิดบนเว็บไซต์เพื่อให้ท่านได้พิจารณาประกอบการทำคำเสนอซื้อ โดยบริษัทจะพยายามตรวจสอบขอมูลดังกล่าวให้ถูกต้องและแม่นยำมากให้ที่สุดเท่าที่จะทำได้ หากกรณีเกิดข้อผิดพลาดเกี่ยวกับข้อมูลความพร้อมในการมีอยู่ของสินค้า ไม่ว่าในส่วนของ ชนิด จำนวน หรือ คุณลักษณะของสินค้า และความสามารถในการจัดส่ง บริษัทจะแจ้งให้ท่านทราบโดยเร็ว และหากพบว่าการดังกล่าวทำให้บริษัทไม่สามารถจัดส่งสินค้าได้ บริษัทมีสิทธิ์ในการยกเลิกคำสั่งซื้อนั้นๆ ได้\n          ในกรณีที่คำสั่งซื้อของท่านถูกยกเลิก แต่ท่านได้ทำการชำระเงินให้บริษัทเรียบร้อยแล้ว ทางบริษัทจะดำเนินการคืนเงินให้ท่านตามนโยบายคืนเงินของบริษัทโดยเร็ว\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("การดำเนินการเกี่ยวกับคำสั่งซื้อสินค้าออนไลน์ ")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          เมื่อท่านได้ทำการสั่งซื้อสินค้าตามขั้นตอนที่ระบุไว้ในเว็บไซต์แล้ว ถือว่าคำสั่งซื้อดังกล่าวเป็นเพียงคำเสนอซื้อของลูกค้าเท่านั้น สัญญาซื้อขายจะยังไม่เป็นผล จนกว่าบริษัทจะได้ทำการยืนยัน หรือตอบรับคำสั่งซื้อของท่านแล้วเท่านั้น\n          หากเกิดกรณีที่สินค้าหมดเป็นครั้งคราว หรือไม่มีสินค้า บริษัทขอสงวนสิทธิ์ในการเสนอสินค้าตัวอื่นที่มีมูลค่าและประเภทใกล้เคียงกันกับสินค้าตามคำเสนอซื้อของท่าน ซึ่งท่านอาจพิจารณารับการเสนอสินค้านั้นหรือไม่ก็ได้ ทั้งนี้บริษัทสามารถเก็บคำสั่งซื้อของท่านไว้จนกว่าสินค้าที่ท่านสั่งซื้อมีอยู่ในคลังสินค้าของบริษัท ในกรณีดังกล่าวบริษัทจะดำเนินการแจ้งถึงความมีอยู่และความพร้อมในการส่งสินค้าในท่านทราบอีกครั้งหนึ่ง ในกรณีที่ท่านไม่ตอบรับการเสนอสินค้าของบริษัท ภายใน 7 วัน\n          บริษัทสงวนสิทธิ์ในการนำสินค้าออกเสนอขายให้ผู้ใช้บริการรายอื่น\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("การยกเลิกคำสั่งซื้อสินค้าออนไลน์ ")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทอาจยกเลิกคำสั่งซื้อของลูกค้า หากปรากฏว่าไม่มีสินค้าชนิดนั้น หรือสินค้านั้นมีการเลิกผลิต หรือเหตุอื่นใดก็ตามที่ทำให้บริษัทไม่สามารรถตอบรับคำสั่งซื้อกับท่านได้ โดยบริษัทจะแจ้งถึงปัญหาดังกล่าวให้ท่านทราบ ในกรณีที่มีการชำระเงินมาแล้ว บริษัทจะทำการคืนเงินตามนโยบายการคืนเงินต่อไป ทั้งนี้ ในกรณีที่ท่านยินยอมให้มีการเปลี่ยนแปลงประเภทและชนิดสินค้า บริษัทจะจัดหาสินค้าอื่นเป็นการทดแทนสินค้าเดิมให้ท่านต่อไป "
              ),
              _c("br"),
              _vm._v(
                "\n          บริษัทขอสงวนสิทธิ์ในการยกเลิกคำสั่งซื้อได้ทันที หากตรวจสอบพบว่า การซื้อขายนั้นไม่ถูกต้องตามเงื่อนไขตามที่บริษัทกำหนด\n          หากคำสั่งซื้อของท่านถูกยกเลิก ท่านจะได้รับการแจ้งเตือนเกี่ยวกับการยกเลิกคำสั่งซื้อนั้นๆ ผ่านอีเมล์ หรือติดต่อผ่านทางโทรศัพท์ ตามข้อมูลที่ท่านให้ไว้ และให้ถือเป้นการแจ้งที่ถูกต้องตามกฎหมาย\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("วิธีการยกเลิกคำสั่งซื้อสินค้า")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          ในกรณีที่ท่านยังไม่ทำการชำระค่าสินค้า หรือ มีการเลือกชำระค่าสินค้าแบบเก็บเงินปลายทาง (COD) ท่านสามารถทำการโทรติดต่อเจ้าหน้าที่ หรือส่งอีเมล์ถึงบริษัท เพื่อแจ้งการยกเลิกการสั่งซื้อ โดยบริษัทจะดำเนินการยกเลิกรายการสั่งซื้อสินค้าดังกล่าวทันที "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n          ในกรณีที่ท่านได้ทำการชำระเงินเสร็จสิ้นแล้ว ไม่ว่าจะเป็นการชำระผ่านบัตรเครดิต หรือชำระแบบเงินสด ให้ท่านทำการโทรติดต่อเจ้าหน้าที่ โดยเจ้าหน้าที่จะดำเนินตรวจสอบสถานะการจัดส่งสินค้าให้ท่าน หากสินค้ายังไม่ได้รับการจัดส่ง บริษัทจะทำการยกเลิกการจัดส่งสินค้าและทำการคืนเงินให้แก่ท่าน ตามรูปแบบการชำระเงินของท่าน ภายใน 15 วันทำการ "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n          ในกรณีที่ท่านไม่ได้มีการโทรแจ้งขอยกเลิกคำสั่งซื้อ แต่ต้องการยกเลิกหลังจากที่สินค้าได้รับจัดส่งถึงท่านจากเจ้าหน้าที่บริษัทขนส่งแล้ว ในกรณีนี้ บริษัทขอสงวนสิทธิ์ในการพิจารณาการยกเลิกคำสั่งซื้อตามความเหมาะสม หากบริษัทแล้วพิจารณาเห็นชอบว่า สามารถยอมรับการยกเลิกได้ บริษัทจะแจ้งให้ท่านดำเนินการคืนสินค้าดังกล่าวให้แก่บริษัทตามนโยบายรับ-ส่งของบริษัท โดยทางบริษัทจะดำเนินการคืนเงินค่าสินค้าให้กับท่าน ตามรายการสินค้าและรูปแบบการชำระเงินของท่าน ภายในระยะเวลา 15 วันทำการ\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("การชำระเงิน")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          การชำระเงินผ่านทางบัตรเครดิต – ท่านจะได้รับการส่งต่อไปยังเว็บภายนอกของบริษัทบัตรเครดิตซึ่งเป็นบุคคลภายนอกสัญญา เพื่อดำเนินการชำระเงินของท่าน โดยการชำระเงินของท่านผ่านเว็บไซต์ดังกล่าวเป็นการตกลงผูกพันท่านตามเงื่อนไขและข้อตกลงของบริษัทบัตรเครดิต และข้อตกลงและเงื่อนไขของเว็บไซต์ภายนอกนั้น "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n          การชำระเงินผ่านทางธนาคารอิเล็กทรอนิกส์ – ท่านจะได้รับการส่งต่อไปยังเว็บภายนอกของบริษัทที่ดำเนินการชำระเงินซึ่งเป็นบุคคลภายนอกสัญญา เพื่อดำเนินการชำระเงินของท่าน โดยการชำระเงินของท่านผ่านเว็บไซต์ดังกล่าวเป็นการตกลงผูกพันท่านตามเงื่อนไขและข้อตกลงของบริษัทที่ดำเนินการชำระเงิน และข้อตกลงและเงื่อนไขของเว็บไซต์ภายนอกนั้น "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n          การชำระเงินทั้งหมดจะขึ้นอยู่กับการอนุมัติของบริษัทที่ดำเนินการชำระเงินซึ่งเป็นบุคคลภายนอกสัญญา และ/หรือ สถาบันการเงิน และบริษัทจะไม่รับผิดใดๆ หากบริษัทที่ดำเนินการชำระเงินซึ่งเป็นบุคคลภายนอกสัญญา และ/หรือ สถาบันการเงิน ปฏิเสธการยอมรับ หรือความน่าเชื่อถือของบัตรเครดิต หรือธุรกรรมทางธนาคารอิเล็กทรอนิกส์ หรือธุรกรรมทางเคาน์เตอร์เซอร์วิส ไม่ว่าด้วยสาเหตุใด ๆ ก็ตาม บริษัทขอสงวนสิทธิ์ดังนี้\n          ใช้ดุลยพินิจในการปฏิเสธการชำระเงินใดๆ โดยไม่จำต้องแจ้งสาเหตุสำหรับการปฏิเสธนั้น\n          เปลี่ยนแปลงเงื่อนไขการชำระเงินสำหรับสินค้าได้ตลอดเวลา คำสั่งซื้อทั้งหมดที่ได้รับผ่านทางเว็บไซต์จะขึ้นอยู่กับการสนองรับคำสั่งซื้อของบริษัท บริษัทอาจยอมรับหรือไม่ยอมรับคำสั่งซื้อของท่านตามดุลยพินิจของบริษัท\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("นโยบายการคืนสินค้าและการคืนเงิน")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          ท่านสามารถเปลี่ยน / คืนสินค้า / เลิกสัญญาได้ภายใน 7 วัน นับตั้งแต่วันที่ได้รับสินค้าหรือบริการ โดยท่านสามารถทำหนังสือแจ้งเจตนายกเลิกสัญญามายังบริษัทฯ โดยหลังจากบริษัทฯ ได้รับหนังสือแจ้งเจตนาของท่านแล้ว ท่านจะได้รับเงินที่ชำระเพื่อซื้อสินค้าหรือบริการคืนเต็มจำนวนภายใน 15 วัน\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("วิธีการคืนสินค้า")]
            ),
            _vm._v(" "),
            _c("span", [
              _vm._v(" ท่านสามารถขอคืนสินค้า ด้วยสาเหตุดังต่อไปนี้ ")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          กล่องบรรจุภัณฑ์ขนส่งสินค้า บุบ ฉีกขาด ไม่สมบูรณ์ กล่องถูกแกะ หรือมีการเปิดสินค้าก่อนรับจากบริษัทขนส่ง\n          กรณีสินค้ามีการจัดส่งผิดรุ่น ผิดสี ผิดขนาด ไม่ตรงตามเว็บไซต์ หรือ สินค้ามีตำหนิ ใช้งานไม่ได้\n          หากท่านตรวจสอบสินค้าและพบว่าสินค้าหรืออุปกรณ์ไม่อยู่ในสภาพที่สมบูรณ์ หรือใช้งานไม่ได้ หรือไม่ตรงเสป็ค ท่านสามารถส่งคืนกลับบริษัทภายใน 7 วันหลังจากได้รับสินค้า อย่างไรก็ตาม บริษัทจะไม่รับผิดชอบในความสูญหายหรือความเสียหายใดๆ ภายหลังจากที่สินค้าหรือบริการได้มีการส่งมอบให้แก่ลูกค้าแล้ว รวมถึงกรณีที่ลูกค้าได้มีคำสั่งให้เจ้าหน้าที่จัดส่งสินค้าวางสินค้าไว้นอกบ้าน\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("วิธีการคืนเงิน")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทจะเริ่มดำเนินการคืนเงินให้กับท่าน หากท่านพิสูจน์ได้ว่าความเสียหายซึ่งเป็นสาเหตุของการคืนสินค้านั้นได้เกิดขึ้นก่อนการส่งมอบสินค้า โดยการคืนเงินจะขึ้นอยู่กับรูปแบบ การชำระเงินของท่าน "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n          กรณีท่านชำระสินค้าผ่านบัตรเครดิตแบบเต็มจำนวน บริษัทจะทำการคืนเงินค่าสินค้า กลับเข้าวงเงินบัญชีบัตรเครดิตที่ท่านใช้ทำการซื้อสินค้า ภายในระยะเวลา 15 วัน (อย่างไรก็ตามระยะเวลาในการคืนวงเงินกลับเข้าบัตรเครดิตของท่าน จะขึ้นอยู่กับนโยบายการดำเนินการของแต่ละธนาคาร ซึ่งอาจจะใช้เวลา 7-45 วัน หลังจากที่ทางบริษัทได้ส่งคำสั่งคืนเงินกลับไปให้ท่านแล้ว) ทั้งนี้ บริษัทขอสงวนสิทธิ์คืนเงินให้แก่ท่านตามข้อมูลชื่อบนบัตรเครดิตที่ตรงตามรายชื่อผู้สั่งซื้อสินค้าบนเว็บไซต์เท่านั้น "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n          กรณีท่านชำระสินค้าผ่านบัญชีธนาคาร เก็บเงินสดปลายทาง หรือเอทีเอ็ม บริษัทจะทำการคืนเงินค่าสินค้าคืนกลับเข้าบัญชีธนาคารที่ท่านได้ทำการแจ้งไว้ ภายในระยะเวลา 15 วัน "
              ),
              _c("br"),
              _vm._v(
                "\n          บริษัทจะคืนเงินตามมูลค่าที่ท่านที่ได้ทำการชำระเงินไว้ ในกรณีที่รายการซื้อสินค้าของท่านที่มีค่าขนส่งรวมอยู่ ทางบริษัทจะดำเนินการคืนเงินค่าขนส่ง รวมกับค่าสินค้าให้กับท่าน ตามรูปแบบการชำระเงิน ภายในระยะเวลาที่กำหนดไว้ 15 วัน โดยเจ้าหน้าที่จะติดต่อแจ้งสถานะการดำเนินการให้ท่านทราบผ่านช่องทาง อีเมล์ หรือ โทรศัพท์\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("การจัดส่งสินค้า")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทจะดำเนินการจัดส่งสินค้าให้กับท่านอย่างรวดเร็ว ภายในระยะเวลา 1 – 3 วันของวันทำการ (ไม่รวมวันหยุดเสาร์และอาทิตย์และวันหยุดนักขัตฤกษ์) นับตั้งแต่วันที่ท่านได้ทำการชำระค่าสินค้า หรือ มีคำสั่งซื้อสมบูรณ์\n          ในกรณีที่การจัดส่งสินค้าได้รับผลกระทบเกิดความล่าช้าจากเหตุสุดวิสัย จากภัยธรรมชาติ การจลาจล กฎระเบียบของหน่วยงานที่เกี่ยวข้อง หรือ มาตรการต่างๆของภาครัฐ ซึ่งส่งผลให้เกิดความล่าช้าในการจัดส่ง กรณีเกิดความล่าช้าเกินกว่า 5 วันทำการ บริษัทจะเร่งประสานงานกับบริษัทขนส่ง เพื่อแก้ไขปัญหาให้ท่านอย่างเหมาะสม\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("กฎข้อบังคับ")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทจะไม่รับผิดชอบต่อความสูญหาย/เสียหายใดๆ และจะไม่รับผิดชอบต่อค่าใช้จ่ายที่เกิดขึ้นไม่ว่าทางตรงหรือทางอ้อม ซึ่งเกิดจากการที่ท่านเข้าใช้เว็บไซต์นี้ หรือเว็บไซต์ที่เชื่อมโยงกับเว็บไซต์นี้ หรือการที่บุคคลใดๆ ถูกขัดขวางการเข้าใช้งานเว็บไซต์หรือไม่สามารถเข้าใช้งานเว็บไซต์ได้ นอกจากนั้น บริษัทจะไม่รับผิดต่อความสูญหาย/เสียหายใดๆ หรือค่าใช้จ่ายที่เกิดจากความล้มเหลวในจากใช้งานเว็บไซต์ ความผิดพลาด การละเว้น การหยุดชะงัก ข้อบกพร่อง ความไม่สมบูรณ์ อันเนื่องมาจากระบบคอมพิวเตอร์ หรือไวรัส\n          ถึงแม้ว่าบริษัทจะได้ทราบถึงการดังกล่าวแล้วก็ตาม\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("กฎหมายที่ใช้บังคับ")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          ข้อตกลงและเงื่อนไขแห่งข้อตกลงฉบับนี้ ให้บังคับและตีความตามกฎหมายของประเทศไทย ข้อพิพาทอื่นใดที่เกิดขึ้นภายใต้หรือเกี่ยวเนื่องกับข้อตกลงและเงื่อนไขแห่งข้อตกลงฉบับนี้ รวมถึงปราศจากข้อจำกัดต่อคำถามอื่นใดในเรื่องความมีอยู่ ความสมบูรณ์ หรือการยกเลิก จะถูกอ้างถึงและได้รับการพิจารณาโดยศาลที่มีเขตอำนาจพิจารณาคดีทั่วไปของประเทศไทยเท่านั้น\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("การลงทะเบียนใช้บริการ")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          ท่านสามารถลงทะเบียนเป็นผู้ใช้บริการสั่งซื้อสินค้าของเว็บไซต์ โดยท่านตกลงที่จะให้ข้อมูลรายละเอียดที่ถูกต้อง ตรงกับความเป็นจริง ทั้งรายชื่อที่ติดต่อ สถานที่ติดต่อ เบอร์โทรศัพท์ เพื่อประโยชน์ในกระบวนการติดต่อ ซื้อขาย ระหว่าง บริษัทกับท่านทุกประการ\n          ในกรณีที่ท่านมีการเปลี่ยนแปลงแก้ไขข้อมูลใดๆ ท่านตกลงแจ้งการเปลี่ยนแปลงแก้ไขนั้นให้บริษัททราบทันที โดยแจ้งแก้ไขผ่านทางเว็บไซต์หรือติดต่อเจ้าหน้าที่ของบริษัท\n          หากท่านมีความประสงค์ขอยกเลิกการลงทะเบียนกับบริษัท ให้ท่านแจ้งขอยกเลิกการลงทะเบียนให้บริษัททราบทันที ทั้งนี้ ให้การยกเลิกนั้นมีผลสมบูรณ์เมื่อบริษัทได้ตอบรับคำเสนอยกเลิกของท่าน โดยการแจ้งกลับผ่านอีเมล์ของท่านเป็นที่เรียบร้อยแล้ว อย่างไรก็ดี บริษัทขอสงวนสิทธิ์ที่จะไม่ทำการยกเลิกการลงทะเบียนและ/หรือคำสั่งซื้อและ/หรือการรับบริการของท่านได้ โดยไม่จำเป็นต้องชี้แจงเหตุผลให้ท่านทราบ\n          อนึ่ง การยกเลิกการลงทะเบียนของท่านไม่มีผลกระทบต่อข้อตกลงและเงื่อนไขในการสั่งซื้อสินค้าหรือรับบริการที่ได้กระทำไปแล้ว และ/หรือการสั่งซื้อสินค้าหรือรับบริการที่เป็นการสั่งซื้อต่อเนื่อง\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("ติดต่อบริการลูกค้า")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          หากท่านพบปัญหาในการเข้าใช้งานเว็บไซต์ หรือต้องการความช่วยเหลือเกี่ยวกับ สินค้าและการใช้งานเว็บไซต์หรือ หากท่านมีข้อร้องเรียน คำแนะนำ หรือข้อเสนอแนะต่อบริษัท ท่านสามารถติดต่อผ่านอีเมล์ของบริษัท หมายเลขโทรศัพท์ หรือที่อยู่ดังนี้"
              ),
              _c("br"),
              _vm._v(
                "\n          บริษัท บีนีท จำกัด 227/70 ม.7 ต.สันผีเสื้อ อ.เมือง จ.เชียงใหม่ เพื่อประโยชน์ของท่านทางเจ้าหน้าที่ของบริษัทจะดำเนินการช่วยเหลือ และอำนวยความสะดวกแก่ท่านอย่างดีที่สุด\n        "
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-150a10c0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-150a10c0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/TermAndConditions.vue
// module id = 2382
// module chunks = 0